import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import { DirtyWrapper } from 'Components';

class ToolboxBackButton extends Component {
  static propTypes = {
    shown: PropTypes.bool,
    ignoreEmptyStringToNull: PropTypes.bool,
    original: PropTypes.any,
    modified: PropTypes.any,
    path: PropTypes.string,
    callback: PropTypes.func,
    disabled: PropTypes.bool,
    /**
     * By default the toolbox back button will look at "page level dirty" which is all the forms currently mounted
     * By setting the watchedForm prop, the toolbox back button will only look at one form
     */
    watchedForm: PropTypes.string,
  };

  static defaultProps = {
    shown: false,
    ignoreEmptyStringToNull: false,
    original: {},
    modified: {},
    path: null,
    callback: () => {},
    watchedForm: null,
  };

  onClick = (e, showDirtyConfirm, showDirtyLinkConfirm) => {
    const { path, callback } = this.props;

    e.preventDefault();

    if (path) {
      showDirtyLinkConfirm(path, callback);
    } else {
      showDirtyConfirm();
    }
  };

  render() {
    const {
      ignoreEmptyStringToNull,
      original,
      modified,
      callback,
      shown,
      watchedForm,
      disabled,
      ...rest
    } = this.props;

    if (!shown) {
      return null;
    }

    return (
      <DirtyWrapper
        manual
        ignoreEmptyStringToNull={ignoreEmptyStringToNull}
        original={original}
        modified={modified}
        isReadOnly={false}
        closeModalYesCallback={callback}
        watchedForm={watchedForm}
      >
        {(showDirtyConfirm, showDirtyLinkConfirm) => (
          <span className={'toolbox-controls left'}>
            <Button
              primary
              className={'toolbox-button'}
              size={'large'}
              content={'Back'}
              disabled={disabled}
              onClick={(e) =>
                this.onClick(e, showDirtyConfirm, showDirtyLinkConfirm)
              }
              {...rest}
            />
          </span>
        )}
      </DirtyWrapper>
    );
  }
}

export { ToolboxBackButton };



// WEBPACK FOOTER //
// ./src/components/toolbox/ToolboxBackButton.js